export default __webpack_public_path__ + "static/media/Login.3d9e29fc.png";